import { RevokeLicenseInDto, RevokeLicenseOutDto } from '../../../types/license.dto'

export const REVOKE_LICENSE = 'REVOKE_LICENSE'
export const REVOKE_LICENSE_SUCCESS = 'REVOKE_LICENSE_SUCCESS'
export const REVOKE_LICENSE_ERROR = 'REVOKE_LICENSE_ERROR'
export const RESET_REVOKE_LICENSE = 'RESET_REVOKE_LICENSE'

export interface RevokeLicense {
  type: typeof REVOKE_LICENSE
  payload: RevokeLicenseOutDto
}

export interface RevokeLicenseSuccess {
  type: typeof REVOKE_LICENSE_SUCCESS
  payload: RevokeLicenseInDto
}

export interface RevokeLicenseError {
  type: typeof REVOKE_LICENSE_ERROR
  payload: string | boolean
}

export interface ResetRevokeLicense {
  type: typeof RESET_REVOKE_LICENSE
  payload: null
}

export interface State {
  data: RevokeLicenseInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | RevokeLicense
  | RevokeLicenseSuccess
  | RevokeLicenseError
  | ResetRevokeLicense
